/**
 * File: mobileNav.js.
 *
 * Import and initialize functions for Mobile Nav
 */

 export default {
  mobileNav: document.querySelector('.mobile-nav'),
  mobileNavHeader: document.querySelector('.mobile-nav-header'),
  init() {
    if (this.mobileNav && this.mobileNavHeader) {
        this.render();
    }
  },
  render() {
    const mobileNav = document.querySelector('.mobile-nav');
    mobileNav.classList.add('mobile-nav--hidden');
    const toggles = document.querySelectorAll('.js-mobile-nav-toggle');

    toggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        mobileNav.classList.toggle('mobile-nav--hidden');
      });
    })

  },
  finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
